module.exports = __webpack_public_path__ + "img/Instagram.b98aed6e.png";